import { createContext, FC, useCallback, useState } from 'react'
import { useImmer } from 'use-immer'

import parametrization from '@service/parametrization'

import type { IParamsCenterContext } from '@base/@types/providers/Config/ParamsCenterProvider'

const ParamsCenterProvider: FC = ({ children }) => {
  const [loading, setLoading] = useState(false)
  const [paramsCenterQuery, setParamsCenterQuery] = useState('')

  const [paramsCenter, updateParamsCenter] = useImmer([])

  const getParamsCenter = useCallback(async () => {
    setLoading(true)

    try {
      try {
        const { data } = await parametrization.getCenters()

        updateParamsCenter((draft: any) => {
          return draft.concat(data.data)
        })
      } catch {
        setLoading(false)
      }
    } catch {
      setLoading(false)
    }

    setLoading(false)
  }, [updateParamsCenter])

  return (
    <ParamsCenterContext.Provider
      value={{
        loading,

        paramsCenterQuery,
        setParamsCenterQuery,

        paramsCenter,
        getParamsCenter
      }}
    >
      {children}
    </ParamsCenterContext.Provider>
  )
}

export default ParamsCenterProvider
export const ParamsCenterContext = createContext<IParamsCenterContext>(
  {} as IParamsCenterContext
)
